// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-input-container{width:100%}span.subheading{font-size:14px}`, "",{"version":3,"sources":["webpack://./app/javascript/components/Proposals/SummaryTab/SummaryTab.scss"],"names":[],"mappings":"AAAA,yBACE,UAAA,CAEF,gBACE,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
